


























































import Vue from 'vue';
import QuizContentNavCard from '@/web/components/quizzes/QuizContentNavCard.vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'AddQuizQuestionModal',
  props: {
    quizId: {
      type: Number,
    },
    position: {
      type: Number,
    },
  },
  components: {
    QuizContentNavCard,
  },
  methods: {
    async createQuizQuestion(question_type) {
      try {
        const data = {
          quiz: this.quizId,
          question_type,
          position: this.position,
        } as QuizQuestionCreateRequest;

        const question = await this.$store.dispatch('quiz/createQuizQuestion', {
          quizId: this.quizId,
          data,
        });

        this.$parent.$emit('question-added', question);

        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS') as string,
          text: this.$t(
            'QUIZZES.MODAL.QUIZ_QUESTION_CREATED_DESCRIPTION'
          ) as string,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t(
              'QUIZZES.NOTIFICATIONS.FAILED_TO_CREATE_QUIZ_QUESTION'
            )}: ${error}`
          ),
          duration: -1,
        });
      } finally {
        this.$emit('close');
      }
    },
  },
});
